import { parse, format } from "date-fns";

import { Box, Stack, Typography } from "@mui/material";

import useLocalization from "../../hooks/useLocalization";

const AvailabilityDisplay = ({ value, emptyMessage }) => {
  const { getMessage } = useLocalization();

  const formatDate = (date) => {
    if (!date) return "";

    // Accept Date objects or ISO/yyyy-MM-dd strings
    const parsed =
      date instanceof Date
        ? date
        : typeof date === "string"
        ? parse(date, "yyyy-MM-dd", new Date())
        : null;

    if (!parsed || isNaN(parsed)) return "";

    return format(parsed, "EEE MMM dd, yyyy");
  };

  return (
    <Stack spacing={1}>
      {Array.isArray(value) && value.length > 0 ? (
        value.map((item) => (
          <Box
            display="flex"
            gap={1}
          >
            <Typography fontSize="10px">
              {item.startsOn
                ? formatDate(item.startsOn)
                : getMessage("startOfSurvey")}
            </Typography>
            <Typography fontSize="10px">{` => `}</Typography>
            <Typography fontSize="10px">
              {item.endsOn
                ? formatDate(item.endsOn)
                : getMessage("endOfSurvey")}
            </Typography>
          </Box>
        ))
      ) : (
        <Typography fontSize="10px">{emptyMessage}</Typography>
      )}
    </Stack>
  );
};

export default AvailabilityDisplay;
